import React from "react";
import { Link } from "react-router-dom";
import { Button, H1, H2 } from "@blueprintjs/core";
import SignUp from "components/SignUp";
import ProductionCanvas from "components/ProductionCanvas";
import { RootProps } from "routes";
import "./Home.scss";

export default class Home extends React.Component<RootProps, any> {
  state: { isSignUpOpen: boolean } = { isSignUpOpen: false };
  componentDidMount() {
    this.setState({ isSignUpOpen: false });
  }

  render() {
    const { routes, user } = this.props;
    const showSignUp = () => {
      this.setState({ isSignUpOpen: true });
    };
    const closeSignUp = () => {
      this.setState({ isSignUpOpen: false });
    };
    return (
      <div className="home">
        <H1>Model, Optimize and Evaluate Energy Storage Systems</H1>
        <div className="home-text">
          The Energy Storage Evaluation Tool (ESET™) is a suite of applications that enables various stakeholders to model, optimize, and evaluate diverse energy storage systems, maximizing stacked benefits across a wide range of grid and end-user applications.
        </div>
        <div className="switch">
          {!user && (
            <Button
              className="switch__button"
              intent="primary"
              text={<>
                <span className="mobile-only">Sign up to evaluate</span>
                <span className="desktop-only">Sign up to evaluate your energy storage systems</span>
              </>}
              onClick={showSignUp}
              rightIcon="arrow-right"
            />
          )}
          {this.state.isSignUpOpen ? <SignUp isOpen={this.state.isSignUpOpen} onClose={closeSignUp} /> : null}
          {user && (
            <Link to="dashboard">
              <Button
                className="switch__button"
                intent="primary"
                text={"Go to evaluation tool"}
                rightIcon="arrow-right"
              />
            </Link>
          )}
        </div>
        <ProductionCanvas routes={routes} user={user} />
        <H2>Featured Projects</H2>
        <div className="home-text">
          PNNL has evaluated more than <span className="number">60</span>{" "}
          <span className="green">energy storage systems</span> across the country using ESET™.
        </div>
        <img src="/images/StorageProjectsMap.png" alt="Storage systems evaluated by ESET" />
      </div>
    );
  }
}
